export const accountAgeBucket = (createdAt) => {
  if (!createdAt) return "unknown";

  const days = (Date.now() - new Date(createdAt).getTime()) / 86400000;

  if (Number.isNaN(days)) return "unknown";
  if (days < 1) return "today";
  if (days < 10) return "0-10d";
  if (days < 30) return "10-30d";
  if (days < 90) return "1-3m";
  return "3m+";
};

export const visitorTraits = ({ user, organization, roles, theme }) => {
  if (!user) return { visitorId: null, traits: {} };

  const visitorId = user.uuid || (user.id != null ? String(user.id) : null);

  const isOwner = !!organization && organization.owner_id == user.id;
  const orgRole = organization?.pivot?.role;
  const orgId = organization?.uuid || organization?.id;

  const traits = {
    user_type: isOwner
      ? "owner"
      : orgRole == 1 || orgRole == 2
        ? "admin"
        : "member",
    account_age: accountAgeBucket(user.created_at),
    has_org: organization ? "yes" : "no",
    org_plan: organization?.hasPlan ? "active" : "none",
    role_count: String(roles?.length ?? 0),
    theme: theme || "light",
    display_mode: window.matchMedia?.("(display-mode: standalone)")?.matches
      ? "pwa"
      : "browser",
  };

  if (orgId) traits.org_id = String(orgId);

  return { visitorId, traits };
};

export const visitorFullName = (user) =>
  `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

export const visitorIdentity = (visitor) => {
  const { visitorId, traits } = visitorTraits(visitor);
  if (!visitorId) return { visitorId: null, friendlyName: null, tags: {} };

  const { user, organization } = visitor;
  const fullName = visitorFullName(user);

  const tags = { ...traits };

  if (fullName) tags.user_name = fullName;
  if (user.mobile) tags.user_mobile = String(user.mobile);
  if (user.id != null) tags.user_ref = String(user.id);
  if (organization?.title) tags.org_title = organization.title;

  const friendlyName =
    [fullName, user.mobile].filter(Boolean).join(" - ") || null;

  return { visitorId, friendlyName, tags };
};

export default visitorTraits;
